import { IconButton, Tooltip } from "@mui/joy";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

type DeleteRowButtonProps = {
    data: any;
    index: number;
    toggle: Function;
}

export function DeleteRowButton({data, index, toggle}:DeleteRowButtonProps) {
    const isDeleted = data[index]?.to_be_deleted === true;// data[index]?.to_be_deleted ?? false;
    return (
      <Tooltip title={`${isDeleted ? 'Restore' : 'Delete'} this entry`}>
      <IconButton
        size="sm"
        color="neutral"
        onClick={() => toggle(index, !isDeleted)}
        sx={{
          bgcolor: 'background.level1',
          // '--variant-outlinedHoverBg': '#FFFFFF6B',
          // '--variant-outlinedActiveBg': '#FFFFFFB8',// theme.palette.background.level1
          '--IconButton-size': '1.65rem',
          'svg': {
            width: '1.05rem',
            height: '1.05rem',
          }
        }}
      >
        {isDeleted === true && (<ReplayRoundedIcon/>)}
        {isDeleted !== true && (<CloseRoundedIcon/>)}
      </IconButton>
      </Tooltip>
    )
}
